import { alpha, useTheme } from "@mui/material/styles";
import { Chip, TableCell, TableRow } from "@mui/material";
import LookupChipCells from "./LookupChipCells";
import TruncatedCell from "./TruncatedCell";
import { useLookupColorMaps } from "../hooks/useLookups";

export default function ListRow({ item, widths, leading, onClick, sx }) {
  const theme = useTheme();
  const colorMaps = useLookupColorMaps();

  const styles = {
    clickableRow: {
      cursor: "pointer",
      "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.06) },
    },
    archivedRow: { opacity: 0.6 },
  };

  return (
    <TableRow
      onClick={onClick}
      sx={[
        onClick ? styles.clickableRow : null,
        item.archived ? styles.archivedRow : null,
        sx,
      ]}
    >
      {leading}
      <TruncatedCell
        value={item.title}
        sx={widths.title}
        after={
          item.archived && (
            <Chip label="Archived" size="small" color="archived" />
          )
        }
      />
      <TruncatedCell value={item.product.join(", ")} sx={widths.product} />
      <TruncatedCell value={item.owner} sx={widths.owner} />
      <LookupChipCells item={item} colorMaps={colorMaps} />
      <TableCell>{item.targetPeriod}</TableCell>
    </TableRow>
  );
}
